import React, { useState } from 'react';
import { get } from 'lodash';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { scrollToFirstFormError } from '../../../Taps/utils/scrollToFormError/scrollToFormError';
import Loading from 'components/Loading';
import Card from 'components/Card/CardNew';
import { apiResponseWrapper } from 'utils/apiResponseWrapper';
import { getPrivileges, setSupportMeasures } from './ArmyMeasuresConfirmationService';
import SupportConfirmation from './ArmyMeasuresConfirmation';
import ArmyMeasuresForm from './ArmyMeasuresForm';

function Index() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { isFetching, data: privileges } = useQuery('getPrivileges', async () => {
    return apiResponseWrapper(await getPrivileges());
  });

  const isArmyMobilized = useSelector((state) => {
    const profile = get(state, 'app.user', Map);
    const profileData = profile.get('data') || {};
    return profileData.get('isArmyMobilized');
  });

  if (isArmyMobilized === false) {
    return (
      <div className={'boo'}>
        <Card className={'mt-3 mb-3 p-3'}>
          <div>По сведениям от Министерства обороны РФ Вы не мобилизованы.</div>
        </Card>
      </div>
    );
  }

  if (error) {
    return (
      <div className={'boo'}>
        <Card className={'mt-3 mb-3 p-3'}>
          <div>{error}</div>
        </Card>
      </div>
    );
  }

  if (isSubmitted) {
    return (
      <div className={'boo'}>
        <SupportConfirmation />
      </div>
    );
  }
  let view = <></>;
  if (isArmyMobilized === true) {
    view = (
      <div className={'boo'}>
        {(isLoading || isFetching) && <Loading />}
        {privileges && (
          <ArmyMeasuresForm
            privileges={privileges}
            onSubmitFail={(e) => setTimeout(() => scrollToFirstFormError(e), 0)}
            onSubmit={async (values) => {
              const arr = [];
              const valuesForSubmit = new Map(values);
              const measuresKeys = privileges.map(({ id }) => id);
              for (let i = 0; i < measuresKeys.length; i++) {
                const id = measuresKeys[i];
                const val = valuesForSubmit.get(`${id}`);
                if (val) {
                  arr.push(id);
                  valuesForSubmit.delete(`${id}`);
                }
              }
              valuesForSubmit.delete('inn');
              valuesForSubmit.delete('firstName');
              valuesForSubmit.delete('middleName');
              valuesForSubmit.delete('lastName');

              valuesForSubmit.set('privilegeIdList', arr);
              setIsLoading(true);
              try {
                const res = await setSupportMeasures(Object.fromEntries(valuesForSubmit));
                apiResponseWrapper(res);
              } catch (error) {
                if (error.errorType === 'message') {
                  setError(error.errorData);
                } else {
                  setError(
                    'Вы превысили лимит по количеству сообщений, направляемых в течение 24 часов.\nПожалуйста, повторите попытку позже.',
                  );
                }
              } finally {
                setIsLoading(false);
                setIsSubmitted(true);
              }
            }}
          />
        )}
      </div>
    );
  }
  return view;
}

export default Index;
